import React, { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navigationItems = [
    { id: 'home', label: 'Home', icon: '🏠', path: '/Portfolio/index.html' },
    { id: 'about', label: 'About', icon: '👤', path: '/Portfolio/about.html' },
    { id: 'projects', label: 'Projects', icon: '💼', path: '/Portfolio/projects.html' },
    { id: 'games', label: 'Games', icon: '🎮', path: '/Games' },
    { id: 'contact', label: 'Contact', icon: '📧', path: '/Portfolio/contact.html' },
];

export const MobileNavigation: React.FC = () => {
    const location = useLocation();
    const isActive = useCallback(
        (path: string) => {
            if (path === '/Games' && location.pathname.startsWith('/Games/')) return true;
            if (location.pathname === path) {
                return true;
            }
            if (path === '/') {
                return location.pathname === '/Portfolio/index.html';
            } else if (path === '/Portfolio/index.html') {
                return location.pathname === '/';
            }
            return false;
        },
        [location.pathname]
    );

    return (
        <nav aria-label='Main navigation' className='shrink-0 bg-gray-900 text-white shadow-lg'>
            {/* Header */}
            <div className='h-10 flex items-center justify-center border-b border-gray-700'>
                <Link to='/Portfolio/index.html' className='text-base font-semibold text-blue-400'>
                    Faris Rehman
                </Link>
            </div>

            {/* Navigation Items */}
            <div className='flex'>
                {navigationItems.map(item => (
                    <Link
                        key={item.id}
                        to={item.path}
                        aria-current={isActive(item.path) ? 'page' : undefined}
                        className={`flex-1 min-h-11 py-2 px-1 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-center transition-colors duration-200 ${
                            isActive(item.path)
                                ? 'bg-blue-600 text-white'
                                : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white'
                        }`}
                    >
                        <span aria-hidden='true' className='text-sm'>
                            {item.icon}
                        </span>
                        <div className='text-xs font-medium'>{item.label}</div>
                    </Link>
                ))}
            </div>
        </nav>
    );
};
